import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { MobileLink } from '../MobileLink'

export const MobileMenuCategory = ({
  title,
  items,
  onItemClick,
  className = '',
}: MobileMenuCategoryProps) => {
  return (
    <details className={`block group ${className}`.trim()}>
      <summary
        className="flex items-center justify-between py-2 text-base font-medium text-red-600 cursor-pointer transition-colors duration-200 hover:text-red-800 list-none focus:outline-none focus:ring-2 focus:ring-vi-red focus:ring-offset-2"
      >
        <span>{title}</span>
        <ChevronRightIcon
          className="w-4 h-4 transition-transform duration-200 flex-shrink-0 group-open:rotate-90"
          aria-hidden="true"
        />
      </summary>
      <div className="pl-4 pt-1 animate-in slide-in-from-top-2 duration-150">
        <div className="flex flex-col gap-1" role="menu">
          {items.map(item => (
            <MobileLink key={item.href} href={item.href} onClick={onItemClick}>
              {item.name}
            </MobileLink>
          ))}
        </div>
      </div>
    </details>
  )
}

interface MobileMenuCategoryProps {
  title: string
  items: {
    name: string
    href: string
  }[]
  onItemClick: () => void
  className?: string
}
